export const PULL_CREDIT = 'PULL_CREDIT';
export const PULL_CREDIT_PENDING = 'PULL_CREDIT_PENDING';
export const PULL_CREDIT_FAILURE = 'PULL_CREDIT_FAILURE';
export const PULL_CREDIT_SUCCESS = 'PULL_CREDIT_SUCCESS';
export const PULL_CREDIT_RESET = 'PULL_CREDIT_RESET';
